import React, { useReducer } from 'react'
import { withStyles } from '@material-ui/core'

import ModalConfirmacao from '../../../components/Modal/ModalConfirmacao/ModalConfirmacao'
import SuccessIcon from '../../../components/Icon/SuccessIcon'
import ModalAssinatura from '../ModalAssinatura/ModalAssinatura'
import { getViziWebUrl } from '../../../config/config'
import { getMensagemAssinaturaPresenca } from '../utils/getDadosMensagem'
import { goToWhatsApp } from '../../../utils/goToWhatsApp'
import { enviarMensagemAssinaturaPresenca, findProfissionalSaudeLogado } from '../../../services/ProntuarioService'

const ModalAssinaturaPresenca = ({
  open,
  onClose,
  classes,
  agendamentoSelected,
}) => {
  const [openModalAssinatura, toggleModalAssinatura] = useReducer(state => !state, false)

  const sendMessageToWhatsapp = async () => {
    const profissionalSaudeLogado = await findProfissionalSaudeLogado()
    if(profissionalSaudeLogado?.utilizaSecretariaVirtual) {
      const numeroTelefone = `${agendamentoSelected.telefoneDDI + agendamentoSelected.telefone}`
      await enviarMensagemAssinaturaPresenca({ numeroTelefone, agendamento: agendamentoSelected })
      onClose()
      return;
    }

    const messageToSendManually = {
      nomePaciente: agendamentoSelected.sujeitoAtencao?.nomeSocialOuNome || agendamentoSelected.nome,
      link: `${getViziWebUrl()}/confirmacao-presenca/${agendamentoSelected.chavePublica}`,
    }
    const messageToSend = getMensagemAssinaturaPresenca(messageToSendManually)
    goToWhatsApp(agendamentoSelected.telefone, agendamentoSelected.telefoneDDI, messageToSend)
    return onClose()
  }

  const modalConfirmacaoProps = {
    idSecondButton: "prt-map-btn-ass",
    labelSecondButton: "Assinar agora",
    handleSecondButton: () => {
      toggleModalAssinatura()
    },
    disabledSecondButton: false,
    idPrimaryButton: "prt-map-btn-wpp",
    labelPrimaryButton: "Enviar por Whatsapp",
    handlePrimaryButton: () => sendMessageToWhatsapp(),
    colorCustomPrimaryButton: "green",
    colorCustomSecondButton: "green",
  }

  return (
    <>
    <ModalConfirmacao
      open={open}
      onClose={onClose}
      classes={{
        paperAlert: classes.paperAlert
       }}
      icon={<SuccessIcon color="white" />}
      title={'Atendimento finalizado!'}
      color={"green"}
      buttons={{
        ...modalConfirmacaoProps
      }}
    >
      <div className={classes.descriptionContainer}>
        <span className={classes.descriptionText}>Solicite a assinatura de presença.</span>
      </div>
    </ModalConfirmacao>
      
    {openModalAssinatura && 
      <ModalAssinatura 
        openModalAssinaturaPresenca={openModalAssinatura}
        handleClose={() => {
          toggleModalAssinatura()
          onClose()
        }}
        dadosAgendamento={agendamentoSelected}
      />}
    </>
  )
}

const styles = {
 paperAlert: {
   minWidth: '450px',
   maxWidth: '500px',
 },
 descriptionContainer: {
   display: 'flex',
   flexDirection: 'column',
   alignItems: 'center',
   justifyContent: 'center'
 },
 descriptionText: {
  fontSize: '18px',
  fontWeight: '400',
  color: '#505050',
   margin: '8px 0'
 }
}

export default withStyles(styles)(ModalAssinaturaPresenca)
